export const getReferralLink = (code: string): string => {
  const baseUrl = process.env.REACT_APP_CLIENT_URL || "https://kazam.ph/";
  const path = `referral/${code.toLowerCase()}`;
  return `${baseUrl}${path}`;
};
